import { Booking } from "@/components/landing/Booking";

export function ContactPage() {
  return (
    <div className="bg-ink">
      <div className="pt-20" />
      <Booking />
    </div>
  );
}
